export default __webpack_public_path__ + "static/media/0i.423c6715.jpg";